module.exports = __webpack_public_path__ + "static/media/Gaurang.708edf4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/team/images/Gaurang.jpg
// module id = 1739
// module chunks = 146